"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputNumber = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const inputnumber_1 = require("primereact/inputnumber");
const react_1 = require("react");
const InputNumber = (props) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange) {
            if (event.value === null) {
                props.onChange();
            }
            else {
                props.onChange(event.value);
            }
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(inputnumber_1.InputNumber, { placeholder: props.placeholder, inputClassName: props.inputClassName, value: props.value, onChange: handleChange, min: props.min }));
};
exports.InputNumber = InputNumber;
